
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { endOfDay, startOfDay } from 'date-fns';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { finalize } from 'rxjs/operators';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PageInfo } from 'src/app/core/models/page-info';
import { QueryMSDCRequest } from 'src/app/core/models/transport-operation/query-msdc-request';
import { DataTablePreference } from 'src/app/core/models/user-preference';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Table } from 'typeorm';
import { MSDCService } from '../../services/msdc.service';

@Component({
  selector: 'laas-msdc-search',
  templateUrl: './msdc-search.component.html',
  styleUrls: ['./msdc-search.component.scss']
})
export class MSDCSearchComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('MSDCDataTable') dataTable!: Table;
  @ViewChild('createDt') createDt!: CalendarComponent;
  readonly viewPermissionCode = PermissionConstants.MSDCSearch;

  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  submitted: boolean = false;
  readonly preferenceKey: string = UserPreferenceConstants.MSDCSearchColumnOrder;
  readonly dayRange: number = 31;

  searchForm: FormGroup;
  searchParams: QueryMSDCRequest = new QueryMSDCRequest();

  pageInfo: PageInfo;
  sortInfo: [{ property: string; direction: number }] | null;

  tableColumns: any[];
  showTableColumns: any[];
  tableValue: any[] = [];
  selectedRowId: any;
  defaultCreateDt: Date[];
  constructor(
      injector: Injector,
      private formBuilder: FormBuilder,
      private msdcService: MSDCService
  ) {
    super(injector);

    this.tableColumns = [
      { field: 'plant', header: 'MSDCSearch.MainTable.Plant', sort: true },
      { field: 'sku', header: 'MSDCSearch.MainTable.SKU', sort: true },
      { field: 'qty', header: 'MSDCSearch.MainTable.Qty', sort: true }, //BigDecimal
      { field: 'remainHours', header: 'MSDCSearch.MainTable.RemainHours', sort: true }, //BigDecimal
      { field: 'unSealDate', header: 'MSDCSearch.MainTable.UnSealDate', dataType: 'date', sort: true },
      { field: 'sealDate', header: 'MSDCSearch.MainTable.SealDate', dataType: 'date', sort: true },
      { field: 'subPackageDate', header: 'MSDCSearch.MainTable.SubPackageDate', dataType: 'date', sort: true },
      { field: 'epsHours', header: 'MSDCSearch.MainTable.EpsHours', sort: true }, //BigDecimal
      { field: 'sourceKey', header: 'MSDCSearch.MainTable.SourceKey', sort: true },
      { field: 'unsealBy', header: 'MSDCSearch.MainTable.UnsealBy', sort: true },
      { field: 'sealBy', header: 'MSDCSearch.MainTable.SealBy', sort: true },
      { field: 'uid', header: 'MSDCSearch.MainTable.UID', sort: true },
      { field: 'label2S', header: 'MSDCSearch.MainTable.Label2S', sort: true },
      { field: 'vendorDc', header: 'MSDCSearch.MainTable.VendorDc', sort: true },
      { field: 'vendorLot', header: 'MSDCSearch.MainTable.VendorLot', sort: true },
      { field: 'vendorId', header: 'MSDCSearch.MainTable.VendorId', sort: true },
      { field: 'idNo', header: 'MSDCSearch.MainTable.IdNo', sort: true },
      { field: 'brand', header: 'MSDCSearch.MainTable.Brand', sort: true },
      { field: 'createDate', header: 'MSDCSearch.MainTable.CreateDt', dataType: 'date', sort: true },
    ]
    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    this.showTableColumns = this.tableColumns;

    this.searchForm = this.formBuilder.group({
      scanId: null,
      createDtStart: startOfDay(new Date().addDays(this.dayRange * -1)),
      createDtEnd: endOfDay(new Date()),
      sku: null,
      plant: null
    })

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.sortInfo = null;
		this.defaultCreateDt = [startOfDay(new Date().addDays(this.dayRange * -1)), endOfDay(new Date())];

  }



  async ngOnInit(): Promise<void>{
    await super.ngOnInit();
  }

  /**
   * 將每行資料加上 row ID 以便識別，且 row ID 其實就是 array index
   *
   * @param array
   */
  putRowId(array: any[]) {
    let rowId = 0;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  /**
   * Get table 顯示哪些欄位
   */
  get selectedColumns(): any[] {
    return this.showTableColumns;
  }

  /**
   * Set table 顯示哪些欄位
   */
  set selectedColumns(cols: any[]) {
    this.showTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  /**
   * Get select row of table
   */
  get selectRow(): any {
    if (isNullOrEmpty(this.selectedRowId)) {
      return null;
    }
    return this.tableValue[this.selectedRowId];
  }

  /**
   * Set select row of table
   */
  set selectRow(rowData: any) {

    // 這支程式只承認 selected, 不承認 unselected
    if (isNullOrEmpty(rowData)) {
      return;
    }

    // 若原本就是 null or undefined, 則只需接值即可.
    if (isNullOrEmpty(this.selectedRowId)) {
      this.selectedRowId = rowData.rowId;
      return;
    }

    // 若 selected 同一行，不用做任何事
    if (this.selectedRowId == rowData.rowId) {
      return;
    }

    this.selectedRowId = rowData.rowId;
  }

  /**
   * Button 查詢
   *
   * @param event
   */
  searchBtnClick(event: any) {
    this.pageInfo.pageIndex = 0;
    this.requestOfQuery();
  }


  /**
   * Table 換頁
   *
   * @param event
   */
  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.requestOfQuery();
  }

  /**
   * Table 排序
   *
   * @param event
   */
  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.requestOfQuery();
  }

  async setPageSize(event: any): Promise<void>{
    this.pageInfo.pageSize = event.rows;
  }

  /**
   * HTTP request of query
   *
   * @param isQuery
   * @returns
   */
  requestOfQuery(isQuery: boolean = true) {
    this.searchParams = deepCopy(this.searchForm.value);
    // Pagination information

    if (isNullOrEmpty(this.searchParams.plant)) {
      this.toastService.warn(this.translateService.instant('MSDCSearch.Message.CheckRequiredFields'));
      return;
    }

    this.searchParams.pageSize = this.pageInfo.pageSize;
    this.searchParams.pageIndex = this.pageInfo.pageIndex;
    this.searchParams.sortInfo = this.sortInfo;
    this.searchParams.scanId = this.searchParams.scanId?.trim() === ""? null : this.searchParams.scanId;
    this.searchParams.sku = this.searchParams.sku?.trim() === ""? null : this.searchParams.sku;
    console.log("searchparams:"+JSON.stringify(this.searchParams));

    this.isLoading = true;



      // Clear selected row ID
      this.selectedRowId = undefined;

      this.msdcService.queryMSDCData(this.searchParams)
          .subscribe({
            next: (result) => {
              const isSuccess = result.flag;
              console.log('result',result)
              if (!isSuccess) {
                console.log("!success:");
                this.toastErrorMessage(result.message);

                this.tableValue = [];
                this.pageInfo = {
                  pageSize: 5,
                  pageIndex: 0,
                  totalRecords: 0,
                  totalPages: 0,
                };

                return;
              }

              // 共 ? 筆
              this.pageInfo.totalRecords = result.totalRecords;

              // Get data
              const msdcDatas = result.recordList;
              this.tableValue = msdcDatas.map((x: any) => {
               // x.customerName = x.companyC + '\n' + x.companyE;
                return x;
              });

              // Initial table value and put row ID
              this.putRowId(this.tableValue);
            },
            error: (err) => {
              this.toastErrorMessage(err.error);

              this.tableValue = [];
              this.pageInfo = {
                pageSize: 5,
                pageIndex: 0,
                totalRecords: 0,
                totalPages: 0,
              };
            },
            complete: () => {
              this.isLoading = false;
              this.isSearchFormOpen = false;
            }
          });


  }

  get dataTablePreference(): DataTablePreference | null {
    return this.userService.preference.dataTablePreferences.find(x => x.tableName === this.preferenceKey) ?? null;
  }

  async exportBtnClick(event: any): Promise<void> {
    this.isLoading = true;
    const params = deepCopy(this.searchForm.value);

    this.msdcService.exportMSDCExcel(params)
    .pipe(finalize(() => { this.isLoading = false; }))
    .subscribe({
      next: result => {
        if (result == null || result.size === 0) {
          this.toastService.info(this.translateService.instant('Common.Toast.NoDataFound'));
          this.loader.hide();
          return;
        }
        const file = result;
        const url = URL.createObjectURL(file);
        const a: any = document.createElement('a');
        file.name = 'MSDC.xlsx';
        a.href = url;
        a.download = file.name;
        a.click();
        URL.revokeObjectURL(url);
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case 'createDt':
        this.searchForm.controls.createDtStart.setValue(date.startDate);
        this.searchForm.controls.createDtEnd.setValue(date.endDate);
        break;
    }
  }
}





